
<template>

<el-row>
    <el-col :span="18">

        <el-form :model="productForm" addAction="business/insertBusinessProducts.action" editAction="business/updateBusinessProducts.action" selectAction="business/selectBusinessProductById.action" v-form :rules="rules" ref="ruleForm" label-width="100px">

            <el-form-item label="商品类型" prop="productType">
                <el-radio-group v-model="productForm.productType">
                    <el-radio :label="1">新车</el-radio>
                    <el-radio :label="3">二手车</el-radio>
                    <el-radio :label="2">汽车用品</el-radio>
                    <el-radio :label="4">其他商品</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="选择车系" v-if="productForm.productType==1||productForm.productType==3" prop="seriesId" :rules="[{ required: !productForm.id, message: '车系不能为空'}]">
                <brand-and-series-select ref="brand-and-series-select" @onChanged="carCategoryChange"></brand-and-series-select>
            </el-form-item>
            <el-form-item label="产品名称" prop="productName">
                <el-input v-model="productForm.productName"></el-input>
            </el-form-item>

            <el-form-item label="价格信息" prop="priceInfo">
                <el-input v-model="productForm.priceInfo"></el-input>
            </el-form-item>
            <el-form-item label="商品信息" prop="productInfo">
                <el-input v-model="productForm.productInfo" type="textarea"></el-input>
            </el-form-item>

            <el-form-item label="产品图片(640*480)" prop="productImgUrl">
              <el-upload
                  multiple
                  ref="productImgUrl"
                  :action="baseUrl+'upload/uploadPic'"
                  v-model="productForm.productImgUrl"
                  :before-upload="beforeAvatarUpload"
                  :data="{floder:'bussinessProduct'}"
                  list-type="picture-card"
                  :file-list="productForm.productImgUrl">
                  <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>

            <el-form-item>
                <el-button type="primary">提交</el-button>
            </el-form-item>

        </el-form>

    </el-col>
</el-row>

</template>

<script>

import ChannelModel from '@/framework/models/channelModel'
import BrandAndSeriesSelect from '@/components/BrandAndSeriesSelect'
import BasicPager from '../../../mixins/BasicPager'
import Config from '@/framework/configs/Config'
export default {
  name: 'add-thematic-dialog',
  extends: BasicPager,
  data: function () {
    return {
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      productForm: {
        productType: 1,
        productInfo: null,
        seriesId: null,
        brandId: null,
        seriesName: null,
        productName: null,
        priceInfo: null,
        productImgUrl: []
      },
      rules: {
        productName: [{
          required: true,
          message: '标题不能为空'
        }, {
          min: 6,
          max: 32,
          message: '长度在 6 到 32 个字符',
          trigger: 'blur'
        }],
        priceInfo: [{
          required: true,
          message: '价格不能为空'
        }],
        productInfo: [{
          required: true,
          message: '商品详情不能为空！'
        }, {
          max: 200,
          message: '商品详情不能超过200字'
        }],
        productImgUrl: [
          {
            required: true,
            message: '产品图片不能为空！',
            trigger: 'change'
          }
        ]
      }
    }
  },
  watch: {
    'productForm.productType': function (productType) {
      this.productForm.brandId = null
      this.productForm.seriesId = null
      this.productForm.seriesName = null
      this.productForm.productName = null
      this.productForm.productImgUrl = []
      this.$refs['brand-and-series-select'].clear()
    }
  },
  components: {
    BrandAndSeriesSelect
  },
  created: function () {
    let params = this.$route.params
    let businessId = parseInt(params.businessId)
    let businessProductId = parseInt(params.businessProductId)
    this.productForm.id = businessProductId
    this.productForm.businessId = businessId
  },
  methods: {
    onSelectInfo: function (dataInfo) {

    },
    carCategoryChange: function (brandInfo, seriesInfo) {
      this.productForm.brandId = brandInfo.id
      this.productForm.productName = seriesInfo.name
      this.productForm.productImgUrl = []

      if (!seriesInfo) {
        this.productForm.productImgUrl = []
        return
      }

      this.productForm.seriesId = seriesInfo.id

      // 添加照片
      if (this.productForm.productType != 3) {
        let name = seriesInfo.imgUrl.replace('https://csz-test.oss-cn-hangzhou.aliyuncs.com/', '').replace('https://csz-public.oss-cn-hangzhou.aliyuncs.com/', '')
        this.productForm.productImgUrl.push({
          name: name,
          url: seriesInfo.imgUrl
        })
      }

      this.productForm.seriesName = seriesInfo.name
    },

    beforeAvatarUpload (file) {
      let _this = this
      var promise = new Promise(function (resolve, reject) {
        const isLt5M = file.size / 1024 / 1024 < 15
        if (!isLt5M) {
          _this.$message.error('上传头像图片大小不能超过 15MB!')
          reject(new Error('上传头像图片大小不能超过 15MB!'))
          return
        }
        var isAllow = false
        var reader = new FileReader()
        reader.onload = function (e) {
          var data = e.target.result
          // 加载图片获取图片真实宽度和高度
          var image = new Image()
          image.onload = function () {
            var width = image.width
            var height = image.height
            if (width === 640 && height === 480) {
              resolve()
            } else {
              _this.$alert('当前图片为' + width + '*' + height + '，图片为' + 640 + '*' + 480 + '最为合适，可能会造成图片效果不好！', '警告', {
                confirmButtonText: '知道了',
                type: 'warning',
                callback: action => {
                  resolve()
                }
              })
            }
          }
          image.src = data
        }
        reader.readAsDataURL(file)
      })
      return promise
    },
    findAllChannels: function (channelName) {
      let _this = this

      let listener = {
        success: function (dataInfo) {
          _this.components[2].prop.options = dataInfo.datas
        }
      }
      ChannelModel.findAllChannels(_this, listener)
    }
  }
}

</script>
